// @ts-strict-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

import { SessionSchema } from '../types/session-schema'

const initialState: SessionSchema = {
	token: null
}

export const sessionSlice = createSlice({
	name: 'session',
	initialState,
	reducers: {
		loadSession: state => {
			const token = Cookies.get('ACCESS_TOKEN')

			if (token) {
				state.token = token
			} else {
				state.token = null
			}
		},
		setSessionToken: (state, action: PayloadAction<string>) => {
			const token = action.payload

			Cookies.set('ACCESS_TOKEN', token, { domain: '.iport.ru', path: '/', expires: 21 })
			state.token = token
		},
		clearSession: state => {
			state.token = null
		}
	}
})

export const { loadSession, setSessionToken, clearSession } = sessionSlice.actions
export const { reducer: sessionReducer } = sessionSlice
